import { RootState } from '../../../store';

export const selectIncomes = ({ categories }: RootState) => categories.incomes;
export const selectSpend = ({ categories }: RootState) => categories.spend;
export const selectAccumulation = ({ categories }: RootState) => categories.accumulation;
export const selectIsAppLoading = ({ categories }: RootState) => categories.isAppLoading;
